/**
 * Utils2 - Handlebars
 * 对 Handlebars 增加了一些扩展
 * Version 1.0.4
 *
 * Require:
 *     Utils2
 *     Handlebars
 *     object-path
 * Additional:
 *     momentjs
 *     Lodash
 */
;(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(["../utils2", "handlebars", "object-path", "moment", "lodash"], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require("../utils2.js"), require('handlebars'), require("object-path"), require("moment"), require("lodash"));
    } else {
        factory(root.utils, root.Handlebars, root.objectPath, root.moment, root._);
    }
}(this, function (utils, handlebars, objectPath, moment, _) {
    if (handlebars) {
        //region
        var argMapping = function () {
            var source = arguments[0];

            if (!source)
                return {};

            var result = {
                __source: source,
                __context: source[source.length - 1]
            };
            for (var i = 0; i < arguments.length - 1; i++) {
                if (source[i] === result.__context)
                    source[i] = null;
                else
                    result[arguments[i + 1]] = source[i];
            }
            return result;
        };
        var getArgTempStorage = function (args) {
            if (!args.__context.data)
                return {};

            return args.__context.data.root.__handlebars_storage__;
        };
        //endregion

        /**
         * @deprecated 已过时 不推荐使用，建议使用?标签替代
         */
        handlebars.registerHelper('compare', function (left, operator, right, options) {
            if (arguments.length < 3) {
                throw new Error('Handlerbars Helper "compare" needs 2 parameters');
            }
            var operators = {
                '==': function (l, r) {
                    return l == r;
                },
                '===': function (l, r) {
                    return l === r;
                },
                '!=': function (l, r) {
                    return l != r;
                },
                '!==': function (l, r) {
                    return l !== r;
                },
                '<': function (l, r) {
                    return l < r;
                },
                '>': function (l, r) {
                    return l > r;
                },
                '<=': function (l, r) {
                    return l <= r;
                },
                '>=': function (l, r) {
                    return l >= r;
                },
                'typeof': function (l, r) {
                    return typeof l === r;
                }
            };

            if (!operators[operator]) {
                throw new Error('Handlerbars Helper "compare" doesn\'t know the operator ' + operator);
            }

            var result = operators[operator](left, right);

            if (result) {
                return options.fn(this);
            } else {
                return options.inverse(this);
            }
        });

        handlebars.registerHelper("math", function (left, operator, right, options) {
            left = parseFloat(left);
            right = parseFloat(right);

            return {
                "+": left + right,
                "-": left - right,
                "*": left * right,
                "/": left / right,
                "%": left % right
            }[operator];
        });

        handlebars.registerHelper("translate", function (value, key, prop, options) {
            if (value == null || key == null || (prop == null && options == null)) {
                return "";
            }

            if (!options && prop) {
                options = prop;
                prop = undefined;
            }

            var dict = options.data.root.__constant__;
            if (!utils.isType(dict, utils.types.object))
                return "";

            var result = dict[key] ? dict[key][value] : null;
            if (result != null && prop) {
                return result[prop];
            } else if (result != null && !prop && result.text) {
                return result.text;
            } else if (result != null && !prop) {
                return result;
            }
            return "";
        });

        handlebars.registerHelper("default", function () {
            var values = Array.from(arguments).slice(0, arguments.length - 1);

            var value = values[0], index = 0;
            while ((value == null || value === "") && index < values.length) {
                value = values[++index];
            }

            return value == null ? "" : value;
        });

        handlebars.registerHelper("?:", function (condition, trueValue, falseValue) {
            return condition ? trueValue : falseValue;
        });

        handlebars.registerHelper("take", function (array, length, mode) {
            var valueArray = array || [];
            var valueLength = Math.floor(length);

            switch (mode) {
                case "both":
                    return [].concat(valueArray.slice(0, valueLength)).concat(valueArray.slice(valueArray.length - valueLength));
                case "reverse":
                    return valueArray.slice(valueArray.length - valueLength);
                default:
                    return valueArray.slice(0, valueLength);
            }
        });

        handlebars.registerHelper("skip", function (array, length, mode) {
            var valueArray = array || [];
            var valueLength = Math.floor(length);

            switch (mode) {
                case "both":
                    return valueArray.slice(length, valueArray.length - valueLength);
                case "reverse":
                    return valueArray.slice(0, valueArray.length - valueLength);
                default:
                    return valueArray.slice(valueLength);
            }
        });

        handlebars.registerHelper("reverse", function (array) {
            return utils.isType(array, utils.types.string) ? array.split("").reverse().join("") : (array || []).reverse();
        });

        handlebars.registerHelper("for", function (from, to, step, options) {
            var result = "";

            //参数容错
            if (!step && !options && to) {
                step = to;
                to = from;
            }
            if (!options && step) {
                options = step;
                step = 1;
            }

            for (var i = from; i < to; i += step) {
                options.data.index = i;
                options.data.first = i === from;
                options.data.last = i >= (to - 1);
                result += options.fn(this);
            }
            return result;
        });

        handlebars.registerHelper("set", function (key, value, options) {
            this[key] = value;
            return "";
        });

        //region slice
        var slice = function (source, number, direction) {
            return direction === "left" ? source.slice(0, number) : source.slice(number);
        };

        handlebars.registerHelper({
            left: function () {
                var args = argMapping(arguments, "source", "number");
                return slice(args.source, args.number, "left");
            },
            right: function () {
                var args = argMapping(arguments, "source", "number");
                return slice(args.source, args.number, "right");
            }
        });
        //endregion

        //region temporary
        var temporary = {
            "-": function () {
                var args = argMapping(arguments, "path", "value");

                objectPath.set(this, args.path, args.value);
                return "";
            },
            ":": function () {
                var args = argMapping(arguments, "path");

                if (!args.path)
                    return this;
                return objectPath.get(this, args.path);
            }
        };
        handlebars.registerDecorator("initTempStorage", function () {
            var args = argMapping(arguments, "fn", "props", "container", "context");
            var tempStorage = {};

            args.container.helpers["-"] = temporary["-"].bind(tempStorage);
            args.container.helpers[":"] = temporary[":"].bind(tempStorage);
        });
        //endregion

        //region time
        handlebars.registerHelper({
            today: function () {
                var args = argMapping(arguments, "format", "section");
                var time = moment();

                switch (args.section) {
                    case "start":
                        time = time.startOf("day");
                        break;
                    case "end":
                        time = time.endOf("day");
                        break;
                }

                return time.format(args.format || "YYYY-MM-DD HH:mm:ss")
            },
            time: function () {
                var args = argMapping(arguments, "source", "format", "isMillisecond");
                return args.source ? moment(args.source, args.isMillisecond ? undefined : "X").format(args.format || "YYYY-MM-DD HH:mm:ss") : "";
            }
        });
        //endregion

        handlebars.registerHelper("_", function () {
            if (arguments.length <= 2)
                return "";

            var fn = arguments[0];
            if (!_[fn])
                return "";

            return _[fn].apply(this, _.slice(arguments, 1, arguments.length - 1));
        });

        handlebars.registerHelper("json", function (value, options) {
            //参数容错
            if (!options && value) {
                options = value;
                value = undefined;
            }

            if (value) {
                return JSON.stringify(value);
            } else {
                var storage = {};
                options.fn(storage);
                return Handlebars.escapeExpression(JSON.stringify(storage));
            }
        });

        //region 条件相关
        var operators = {
            eq: function (left, right) {
                return left == right;
            },
            is: function (left, right) {
                return left === right;
            },
            neq: function (left, right) {
                return left != right;
            },
            not: function (left, right, options) {
                if (!options && right) {
                    options = right;
                    right = undefined;
                }

                return left !== (right === undefined ? true : right);
            },
            lt: function (left, right) {
                return left < right;
            },
            lte: function (left, right) {
                return left <= right;
            },
            gt: function (left, right) {
                return left > right;
            },
            gte: function (left, right) {
                return left >= right;
            },
            "typeof": function (left, right) {
                return typeof left === right;
            },
            "isType": function (value, type) {
                return utils.isType(value, type);
            },
            "notType": function (value, type) {
                return !utils.isType(value, type);
            }
        };
        var conditions = {
            and: function () {
                var result = true;
                for (var i = 0; i < arguments.length - 1; i++) {
                    if (!arguments[i]) {
                        result = false;
                        break;
                    }
                }
                return result;
            },
            or: function () {
                var result = false;
                for (var i = 0; i < arguments.length - 1; i++) {
                    if (arguments[i]) {
                        result = true;
                        break;
                    }
                }
                return result;
            }
        };
        handlebars.registerHelper({
            /**
             * 多参数条件块（内置行为：&&）
             */
            switcher: function () {
                var options = arguments[arguments.length - 1];
                var result = true;
                for (var i = 0; i < arguments.length - 1; i++) {
                    if (!arguments[i]) {
                        result = false;
                        break;
                    }
                }

                return options[result ? "fn" : "inverse"](this);
            },

            /**
             * 条件匹配
             * @param left 表达式A
             * @param operator 操作符
             * @param right 表达式B
             * @param options
             * @returns {boolean}
             */
            "?": function (left, operator, right, options) {
                if (options === null || options === undefined) {
                    throw new Error('Handlerbars Helper "?" needs 3 parameters')
                }

                var op = operator;
                switch (operator) {
                    case "==":
                        op = "eq";
                        break;
                    case "===":
                        op = "is";
                        break;
                    case "!=":
                        op = "neq";
                        break;
                    case "!==":
                        op = "not";
                        break;
                    case "<":
                        op = "lt";
                        break;
                    case "<=":
                        op = "lte";
                        break;
                    case ">":
                        op = "gt";
                        break;
                    case ">=":
                        op = "gte";
                        break;
                }

                return operators[op] ? operators[op](left, right, {}) : false;
            },

            "invert": function (value, options) {
                if (options === null || options === undefined) {
                    throw new Error('Handlerbars Helper "invert" needs 1 parameters')
                }

                return !value;
            },
            "exists": function (value, options) {
                if (options === null || options === undefined) {
                    throw new Error('Handlerbars Helper "exists" needs 1 parameters')
                }

                return value !== undefined && value !== null;
            },
            "isUndefined": function (value, options) {
                if (options === null || options === undefined) {
                    throw new Error('Handlerbars Helper "isUndefined" needs 1 parameters')
                }

                return value === undefined;
            },
            "isNull": function (value, options) {
                if (options === null || options === undefined) {
                    throw new Error('Handlerbars Helper "isNull" needs 1 parameters')
                }

                return value === null;
            },
            "empty": function (value, options) {
                if (options === null || options === undefined) {
                    throw new Error('Handlerbars Helper "empty" needs 1 parameters')
                }

                return value === undefined || value === null || value === "";
            },
            "isNaN": function (value, options) {
                if (options === null || options === undefined) {
                    throw new Error('Handlerbars Helper "isNaN" needs 1 parameters')
                }

                return isNaN(value);
            }
        });
        handlebars.registerHelper(conditions);
        handlebars.registerHelper(operators);
        //endregion
    }

    /**
     * 简化 Handlebars 模板生成和调用
     * @param template 模版文本
     * @param param 传入模板的参数，若不填则返回模板对象，填入则返回生成后的文本
     * @returns {*}
     */
    utils.template = function (template, param) {
        if (!handlebars)
            return {};

        var compiled = handlebars.compile(template + "{{* initTempStorage}}");
        return param ? compiled(param) : compiled;
    }
}));